<template>
  <v-data-table
    :headers="headers"
    :items="body2Cars"
    :search="search"
    :loading="isTableLoading"
    item-key="id"
    multi-sort
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-btn
          color="primary"
          class="m-2"
          @click="loadBody2"
        >
          <v-icon left>
            mdi-refresh
          </v-icon>
          更新
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clear-icon="mdi-close-circle"
          label="Search"
          clearable
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data() {
    return {
      body2Cars: [],
      isTableLoading: false,
      search: '',
      headers: [
        {
          text: '車牌',
          value: 'licensePlate',
          width: '30%',
        },
        {
          text: '車種',
          value: 'type',
          width: '25%',
        },

        {
          text: '來源',
          value: 'operator',
          width: '20%',
        }
      ],
    }
  },

  computed: {
  },

  watch: {
    dialogUploadVisible(visible) {
      if (!visible) {
        this.$refs.form.reset();
      }
    }
  },

  created () {
    this.loadBody2();
  },

  methods: {
    loadBody2() {
      this.isTableLoading = true;
      this.licensePlates = [];
      this.axios.get('api/taxi')
        .then((resp) => {
          this.body2Cars = [];
          resp.data.forEach(item => {
            this.body2Cars.push({
              id: item.id,
              licensePlate: item.licensePlate,
              type: item.type,
              operator: item.operator,
            });
          });
        })
        .catch(err => alert(err))
        .then(() => this.isTableLoading = false);
    },
  },
}
</script>
